import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { addEventListenerIfNotExists, QueryParameter } from './common';


export default class VisualizationToggle {
    toggleButtonId: string = '#visualization-toggle-button';
    toggleButton: HTMLElement;
    visualizationGuidKey: string = "currentLogoGuid";

    init(): void {
        window.setTimeout(() => this.checkActiviationAndToggleRecursively(0), 250);
    }

    private registerButtonClickListener(): void {
        var button = <HTMLElement>document.querySelector(this.toggleButtonId);

        addEventListenerIfNotExists(button, "click", () => {
            this.toggleLogo();
        });
    }

    // Both objects come from promotron.js; the toggle reads and switches the logo only once both exist.
    private isTronLogoReady(): boolean {
        return window.tronlogo != undefined && typeof window.tron?.User?.getUserLogo === "function";
    }

    private checkActiviationAndToggleRecursively(tronLogoCheckCounter: number) {
        if (this.isTronLogoReady()) {
            var isVizualized = this.isLogoVizualized();
            this.reloadToggleVizualizationComponent(isVizualized);
            return;
        }

        tronLogoCheckCounter = tronLogoCheckCounter + 1;
        if (tronLogoCheckCounter < 40) {
            window.setTimeout(() => this.checkActiviationAndToggleRecursively(tronLogoCheckCounter), 250);
        }
    }

    private toggleLogo() {
        if (!this.isTronLogoReady()) {
            return;
        }

        var isVizualized = this.isLogoVizualized();

        if (isVizualized) {
            sessionStorage.setItem(this.visualizationGuidKey, window.tronlogo.getCurrentLogo());
            window.tronlogo.setCurrentLogo(null);
            this.reloadToggleVizualizationComponent(false);
            return;
        }

        var storedLogo = sessionStorage.getItem(this.visualizationGuidKey);
        if (storedLogo && storedLogo != "") {
            window.tronlogo.setCurrentLogo(storedLogo);
            sessionStorage.setItem(this.visualizationGuidKey, storedLogo);
            this.reloadToggleVizualizationComponent(true);
            return;
        }

        window.tronlogo.toggleVisualization();
        this.reloadToggleVizualizationComponent(true);
    }

    private reloadToggleVizualizationComponent(isVisualized: boolean) {
        var queryParams: QueryParameter[] = [
            { key: 'ajax', value: "true" },
            { key: 'IsVisualized', value: isVisualized.toString() }
        ];

        const action = new ActionCreator().reloadComponent('VisualizationToggle', queryParams);
        action.successAction = () => this.registerButtonClickListener();
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private isLogoVizualized(): boolean {
        if (!this.isTronLogoReady()) {
            return false;
        }

        var currentLogo = window.tronlogo.getCurrentLogo();
        return currentLogo != undefined && currentLogo != null && currentLogo != '';
    }
}



